mutation SetAnnotationsOnCharacters($barMitzvah: String!, $sentence: ID!, $annotations: [AnnotationInput!]!, $overlay: ID) {
  setAnnotationsOnCharacters(barMitzvah: $barMitzvah, sentence: $sentence, annotations: $annotations, overlay: $overlay) {
    ok
    errors
  }
}
